import React from 'react';
import styles from './style.module.css';
import IframeResize from "../../../../common/components/iframe-resize";

export default () => (
    <div className={styles.page}>
        <h1 className={'invisible'}>Inflation and your Retirement Income Calculator</h1>
        <iframe src="https://www.financialcalculators.net/librocu/inflation-income/" title="Inflation and your Retirement Income Calculator" scrolling="no" frameBorder="0"> </iframe>
        <IframeResize/>
    </div>
);
